import { dict, fdepend_t, fitem_t, option_t, product_t } from 'src/types'

import { deep_copy } from './commons.utils'

export const sort_products = (products: product_t[] = []): product_t[] => {
  const products_ = deep_copy(products)
  products_?.sort(({ product_code: pc1 = '' }, { product_code: pc2 = '' }) => {
    return pc1 < pc2 ? -1 : 1
  })
  return products_
}

export const sort_fpool = (fpool: fitem_t[] = []): fitem_t[] => {
  const newpool = deep_copy(fpool)
  newpool?.sort(({ order: o1 = 0 }, { order: o2 = 0 }) => o1 - o2)
  return newpool
}

export const sort_options = (options: option_t[] = []): option_t[] => {
  const options_ = deep_copy(options)
  options_?.sort(({ order: o1 = 0 }, { order: o2 = 0 }) => o1 - o2)
  return options_
}

export const sort_dependencies = (dependencies: dict<fdepend_t> = {}): string[] => {
  const depends_ = Object.keys(dependencies)?.sort((d1, d2) => {
    if (d1 === '*') return -1
    if (d2 === '*') return 1
    if (d1 === '') return -1
    if (d2 === '') return 1
    return d1 < d2 ? 1 : -1
  })
  return depends_
}

export const sort_maximals = (maximals: option_t[] = []): option_t[] => {
  const maximals_ = deep_copy(maximals)
  maximals_?.sort(({ key: k1 }, { key: k2 }) => Number(k1) - Number(k2))
  return maximals_
}
